import React from 'react';

import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';
import ActiveDirectDebitFields from './ActiveDirectDebitFields';
import { CalloutComponent } from '../../common/CalloutComponent';
import ManagePaymentActionCreator from '../../../actions/ManagePaymentActionCreator';
import EditPaymentsStore_new from '../../../stores/EditPaymentsStore_new';
import StringConstant from '../../../constants/StringConstants';
import SvgIcon from '../../common/SvgIcon';
import ErrorPopUpComponent from '../../common/ErrorPopUpComponent';
import LoaderComponent from '../../common/LoaderComponent';

class CancelDirectDebitModal extends React.Component {
  constructor(props) {
    super(props);
    this.cancelDirectDebit = this.cancelDirectDebit.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = {
      showModal: 'VIEW',
    };
  }
  componentWillMount() {
    EditPaymentsStore_new.addChangeListener(this.onStoreChange);
  }
  onStoreChange() {
    const cancelPaymentResponse =
      EditPaymentsStore_new.getCancelPaymentResponse();
    if (cancelPaymentResponse.code === 201) {
      this.setState({ showModal: 'SUCCESS' });
    } else {
      this.setState({ showModal: 'FAILURE' });
    }
  }
  componentDidMount() {}
  componentWillUnmount() {
    EditPaymentsStore_new.removeChangeListener(this.onStoreChange);
  }
  modalBody() {
    return (
      <div>
        <p>{this.props.content.cancelDDInfo}</p>
        <CalloutComponent
          dClass="callout callout__full"
          paraText={this.props.content.after4pmMessageDD}
        />
        <ActiveDirectDebitFields activeData={this.props.cancelPaymentData} />
      </div>
    );
  }
  cancelDirectDebit() {
    this.setState({ showModal: 'LOADER' });
    ManagePaymentActionCreator.cancelPayment(this.props.cancelPaymentData);
  }
  closeErrorPopup() {
    this.setState({ showModal: 'LOADER' });
  }
  successBody() {
    return (
      <div>
        <SvgIcon id="icon-success" width="128px" height="128px" />
        <h3>{StringConstant.cancelledDDSuccessHeader}</h3>
        <p>{StringConstant.cancelledDDSOSuccessBody}</p>
      </div>
    );
  }
  render() {
    switch (this.state.showModal) {
      case 'VIEW':
        return (
          <PatternLibModalComponent
            customClass={'c-modal  review-modal'}
            show
            onHide={this.props.closeModal}
            bsSize={'large'}
            modalHeading={StringConstant.cancelDDHeader}
            modalBody={this.modalBody()}
            modalInContainer={false}
            modalFooter={
              <div>
                <button
                  onClick={this.props.closeModal}
                  className="c-btn c-btn--secondary c-modal__button"
                >
                  {StringConstant.close}
                </button>
                &nbsp;
                <button
                  className="c-btn c-btn--default c-modal__button"
                  onClick={this.cancelDirectDebit}
                >
                  {StringConstant.cancelDDButton}
                </button>
              </div>
            }
          />
        );
      case 'LOADER':
        return (
          <PatternLibModalComponent
            customClass={'c-modal  c-modal--center'}
            show
            onHide={this.props.closeModal}
            bsSize={'large'}
            closeButton={false}
            modalHeading={''}
            modalBody={<LoaderComponent type="small" />}
            modalInContainer={false}
            modalFooter={''}
          />
        );
      case 'SUCCESS':
        return (
          <PatternLibModalComponent
            customClass={'c-modal c-modal--center'}
            show
            modalHeading={''}
            onHide={this.props.closeModal}
            bsSize={'large'}
            modalFooter={
              <button
                onClick={this.props.closeModal}
                className="c-btn c-btn--default c-modal__button"
              >
                {StringConstant.ok}
              </button>
            }
            modalBody={this.successBody()}
            modalInContainer={false}
          />
        );
      case 'FAILURE':
        const response = EditPaymentsStore_new.getCancelPaymentResponse();
        return (
          <ErrorPopUpComponent
            error={response.error}
            closeErrorPopup={this.props.closeModal}
            content={this.props.contents}
          />
        );
    }
  }
}
export default CancelDirectDebitModal;
